var _path, _path2, _use, _use2, _use3, _use4, _use5, _use6, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    id: "flag-icon-css-my",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .05h512v512H0z",
    fill: "#cc0001"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 475.48h512v36.57H0z",
    fill: "#fff",
    id: "a"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -73.143)",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -146.286)",
    width: "100%",
    height: "100%"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -219.43)",
    width: "100%",
    height: "100%"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -292.57)",
    width: "100%",
    height: "100%"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -365.714)",
    width: "100%",
    height: "100%"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -438.857)",
    width: "100%",
    height: "100%"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 .05h320.077v292.57H0z",
    fill: "#010066"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.812 51.9c-51.45 0-93.21 41.621-93.21 92.9 0 51.28 41.76 92.903 93.21 92.903 18.59 0 35.908-5.44 50.454-14.798a82.693 82.693 0 0 1-27.025 4.522c-45.623 0-82.65-36.904-82.65-82.375 0-45.472 37.027-82.376 82.65-82.376 10.082 0 19.74 1.8 28.676 5.1-14.877-10.02-32.81-15.877-52.105-15.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.39 193.164l-39.263-20.486 11.61 41.926-26.262-35.071-8.193 42.686-8.058-42.71-26.372 34.991 11.741-41.89-39.328 20.367 29.216-32.774-44.495 1.709 40.903-17.166-40.848-17.289 44.489 1.843-29.112-32.862 39.264 20.486-11.61-41.926 26.262 35.071 8.193-42.686 8.058 42.71 26.372-34.991-11.742 41.89 39.328-20.367-29.215 32.774 44.494-1.709-40.902 17.166 40.848 17.288-44.489-1.842z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.d39816cdb5d304f7071056b164441061.svg";
export { ForwardRef as ReactComponent };